export default __webpack_public_path__ + "static/media/edit.6a87a416.svg";